(() => {
  let pendingCartRequest = null;
  let cartMutationTimer = null;

  const updateCartCount = (value) => {
    const count = Math.max(0, Number(value) || 0);
    document.querySelectorAll('[data-tl-cart-count]').forEach((bubble) => {
      bubble.textContent = String(count);
      bubble.hidden = count === 0;
    });
    document.querySelectorAll('[data-tl-cart-count-label]').forEach((label) => {
      label.textContent = `カート内の商品数：${count}`;
    });
    document.querySelectorAll('[data-tl-cart-link]').forEach((link) => {
      link.setAttribute('aria-label', `カート、商品数${count}`);
    });
  };

  const fetchCartCount = () => {
    if (pendingCartRequest) return pendingCartRequest;
    const cartUrl = window.routes?.cart_url || '/cart';
    pendingCartRequest = fetch(`${cartUrl}.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
        return response.json();
      })
      .then((cart) => updateCartCount(cart.item_count))
      .catch((error) => console.warn('[tl-cart-count] カート数量の取得に失敗しました。', error))
      .finally(() => { pendingCartRequest = null; });
    return pendingCartRequest;
  };

  const onCartUpdate = (event) => {
    const count = event?.cartData?.item_count;
    if (Number.isFinite(Number(count))) updateCartCount(count);
    else fetchCartCount();
  };

  const observeCartChanges = () => {
    if (window.tlCartCountObserver) window.tlCartCountObserver.disconnect();

    const cartRoots = document.querySelectorAll('cart-items, cart-drawer-items');
    if (!cartRoots.length || typeof MutationObserver === 'undefined') return;

    window.tlCartCountObserver = new MutationObserver(() => {
      window.clearTimeout(cartMutationTimer);
      cartMutationTimer = window.setTimeout(fetchCartCount, 100);
    });

    cartRoots.forEach((root) => {
      window.tlCartCountObserver.observe(root, { childList: true, subtree: true });
    });
  };

  const initialize = () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      window.tlCartCountUnsubscribe?.();
      window.tlCartCountUnsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
    }
    observeCartChanges();
    document.addEventListener('shopify:section:load', () => {
      observeCartChanges();
      fetchCartCount();
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
